export enum PeriodType {
  DAILY,
  WEEKLY,
  MONTHLY,
  ANNUAL
}
